import { flashTimeline } from '@/mocks/home';
import { getTone } from '@/pages/home/lib/tone';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function FlashTimeline() {
  return (
    <section id="flash" className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto max-w-[1280px]">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading
            kicker="News Flash / 快讯时间线"
            index="02 — 今日更新 6 条"
            title="按时间读反差，一条也不跳过"
            desc="快讯只记录公开可查的片段，标注时间点，方便你把它放回原本的语境里。"
          />
          <a
            href="#dossier"
            className="mb-1 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950 px-4 py-2 font-label text-sm text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
          >
            进入完整档案架
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="relative mt-10">
          <span className="absolute bottom-4 left-[78px] top-4 hidden w-px bg-foreground-950/15 md:block" />

          <ol>
            {flashTimeline.map((item) => {
              const tone = getTone(item.tagTone);
              return (
                <li
                  key={item.id}
                  className="grid grid-cols-1 gap-2 border-b border-foreground-950/10 py-5 md:grid-cols-[78px_1fr] md:gap-8"
                >
                  <div className="flex items-center gap-3 md:block">
                    <span className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
                      {item.time}
                    </span>
                    <span className={`rounded-full px-2.5 py-0.5 font-label text-[11px] md:hidden ${tone.softBg} ${tone.softText}`}>
                      {item.tag}
                    </span>
                  </div>

                  <div className="relative">
                    <span
                      className={`absolute -left-[37px] top-2.5 hidden h-2.5 w-2.5 rounded-full ring-4 ring-background-100 md:block ${tone.solidBg}`}
                    />
                    <div className="flex flex-wrap items-center gap-2">
                      <span className={`hidden rounded-full px-2.5 py-0.5 font-label text-[11px] md:inline-block ${tone.softBg} ${tone.softText}`}>
                        {item.tag}
                      </span>
                      <span className="font-label text-[11px] tracking-wider text-foreground-400">
                        热度 {item.heat}
                      </span>
                    </div>

                    <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-xl">
                      <a href="#dossier" className="transition-colors hover:text-primary-600">
                        {item.title}
                      </a>
                    </h3>
                    <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">{item.summary}</p>

                    <div className="mt-3 flex items-center gap-3">
                      <div className="h-1.5 w-full max-w-[180px] overflow-hidden rounded-full bg-background-300">
                        <div className={`h-full rounded-full ${tone.solidBg}`} style={{ width: `${item.heat}%` }} />
                      </div>
                      <span className="font-label text-[11px] text-foreground-500">热度指数</span>
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}